// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc701bfb","453":"46dc3e92","455":"c81c1e89"}[chunkId] + ".chunk.js";
};